module.exports = __webpack_public_path__ + "img/carriere.535cf04c.jpg";